import { IconButton } from '@material-ui/core';
import cx from 'classnames';

import { IconCloseThin } from 'src/assets/icons/CloseThin';
import { IconWebinar } from 'src/assets/icons/IconWebinar';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { ANYWORD_WEBINAR_URL } from 'src/data/common';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const WebinarBanner = ({ className }) => {
  const styles = useStyles();

  const { handleClose, handleClick } = useHandlers({ url: ANYWORD_WEBINAR_URL });

  return (
    <CustomButtonBase
      className={cx(styles.root, className)}
      href={ANYWORD_WEBINAR_URL}
      onClick={handleClick}
      target="_blank"
      rel="noreferrer"
    >
      <CustomTypography className={styles.webinarTag}>
        <IconWebinar className={styles.iconWebinar} />
        Webinar
      </CustomTypography>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.semiBold14}
      >
        Unlock the secrets to building a global B2B brand | Anyword & Gong |{' '}
        <span className={styles.time}>October 29th, 2024 9:30am PDT / 12:30pm EDT</span>
      </CustomTypography>
      <CustomTypography
        className={styles.button}
        variant={TYPOGRAPHY_VARIANT.medium14}
      >
        Save your spot
      </CustomTypography>
      <IconButton
        onClick={handleClose}
        className={styles.closeButton}
      >
        <IconCloseThin className={styles.closeIcon} />
      </IconButton>
    </CustomButtonBase>
  );
};
